<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Send a link to reset password</p>
    </header>

    <div class="modal-card-body">Send a link to reset password холбоос и-мэйл рүү илгээх.</div>

    <footer class="modal-card-foot">
      <button
        class="button"
        type="button"
        @click="$parent.close()"
        :disabled="form.processing"
      >Close</button>

      <button
        class="button is-primary"
        type="button"
        @click="send"
        :class="{ 'is-loading': form.processing }"
      >Илгээх</button>
    </footer>
  </div>
</template>

<script>
export default {
  props: ["userId"],

  data() {
    return {
      sending: false,

      form: new window.Form({})
    };
  },

  methods: {
    send() {
      this.form
        .post(`/admin/api/users/${this.userId}/password-resets`)
        .then(() => {
          this.$parent.close();

          this.$buefy.toast.open("Password reset link has been sent to user.");
        });
    }
  }
};
</script>
